export function isFunction(v: any): boolean {
  return typeof v === 'function';
}
